<script>
    export let project;
</script>

<span class="project-title-tag">{project.title}</span>

<style>
    .project-title-tag {
        background: #D3EFFF;
        color: #333;
        padding: 4px 4px;
        display: inline-block;
        font-weight: 500;
        margin: 0 2px;
    }
</style>